import { QUOTA_EXCEEDED, QUOTA_DISMISSED } from './quotaTypes';

export const quotaExceeded = (payload) => ({
  type: QUOTA_EXCEEDED,
  payload,
});

export const quotaDismissed = () => ({
  type: QUOTA_DISMISSED,
});
